export default "__VITE_ASSET__Bu00zDTM__"